import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AngularYandexMapsModule } from 'angular8-yandex-maps';
import { LabPassComponent } from './lab-pass.component';
import { LabPassRoutingModule } from './lab-pass-routing.module';
import { AdvantageComponent } from './components/advantage/advantage.component';
import { AdvantageItemComponent } from './components/advantage/components/advantage-item/advantage-item.component';
import { BannerComponent } from './components/banner/banner.component';
import { DownloadAppComponent } from './components/download-app/download-app.component';
import { QuestionsComponent } from './components/questions/questions.component';
import { WhereUseComponent } from './components/where-use/where-use.component';
import { HowWorkComponent } from './components/how-work/how-work.component';
import { FormQuestionsComponent } from './components/form-questions/form-questions.component';
import { MapComponent } from './components/map/map.component';
import { BalloonMobileModule } from '@shared/modules/map/modules/balloon-mobile/balloon-mobile.module';
import { DeclensionModule } from '@shared/pipes/declension/declension.module';
import { FormatLinkPipe } from '@shared/pipes/format-link/format-link.pipe';
import { BreadcrumbModule } from '@shared/modules/breadcrumb/breadcrumb.module';
import { MobileAppsLinksComponent } from '@shared/components/mobile-apps-links/mobile-apps-links.component';

@NgModule({
  declarations: [
    LabPassComponent,
    AdvantageComponent,
    AdvantageItemComponent,
    BannerComponent,
    DownloadAppComponent,
    QuestionsComponent,
    WhereUseComponent,
    HowWorkComponent,
    FormQuestionsComponent,
    MapComponent,
  ],
  imports: [
    CommonModule,
    LabPassRoutingModule,
    NzCollapseModule,
    ReactiveFormsModule,
    CarouselModule,
    AngularYandexMapsModule,
    BalloonMobileModule,
    DeclensionModule,
    FormatLinkPipe,
    BreadcrumbModule,
    MobileAppsLinksComponent,
  ],
})
export class LabPassModule {}
